import { useState, useEffect } from 'react'
import SearchMainHeader from './Search'
import LogoMainHeader from './Logo'
import style from './style.module.scss'
import BurgerMainHeader from './Burger'
import DonationMainHeader from './Donation'
import MenuMain from './Menu'
import useMediaQuery from '@mui/material/useMediaQuery'

const MainHeader = ({ menu, langs, responsiveMenu, donation }) => {
    const [open, setOpen] = useState(false)
    const mobile = useMediaQuery(`(max-width:${style.mobileBreakpoint})`)

    useEffect(() => {
        if (open) {
            document.body.style.overflowY = 'hidden'
        } else {
            document.body.style.overflowY = 'visible'
        }
    }, [open])

    return (
        <div className={style.main}>
            <div className={style.left}>
                {mobile && <BurgerMainHeader open={open} setOpen={setOpen} />}
                {!mobile && <LogoMainHeader />}
            </div>

            <div className={style.right}>
                {!mobile && <SearchMainHeader />}
                {!mobile && <BurgerMainHeader open={open} setOpen={setOpen} />}
                {mobile && <LogoMainHeader />}
                <DonationMainHeader donation={donation} />
            </div>

            <MenuMain menu={menu} open={open} langs={langs} responsiveMenu={responsiveMenu} />
        </div>
    )
}

export default MainHeader
